import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';

/**
 * A signed URL for a pathway's outcome letter PDF, through the guarded
 * callable (rmsFetchTriageDocument). The server serves it only to a role the
 * letter was sent to, so a caller never needs its own permission check.
 * `disposition` is 'inline' (to show it) or 'attachment' (to save it).
 */
export function fetchTriageLetterUrl({ orgId, patientRecordId, pathway, disposition }) {
  const fn = httpsCallable(functions, 'rmsFetchTriageDocument', { timeout: 30000 });
  return fn({ orgId, patientRecordId, fileFormat: 'pdf', disposition, pathway });
}

/**
 * Save a pathway's outcome letter: the letter page's Download and the pupil
 * record's letter row both use this, so the two can never fetch differently.
 * Rejects when the server returns no file, so the caller can say so.
 */
export async function downloadTriageLetter({ orgId, patientRecordId, pathway }) {
  const res = await fetchTriageLetterUrl({ orgId, patientRecordId, pathway, disposition: 'attachment' });
  const url = res?.data?.downloadUrl;
  if (!url) throw new Error('The outcome letter could not be fetched.');
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
